import React, { useState } from 'react'
import qs from 'qs'
import classNames from 'classnames'
import util from 'meinian-package/src/utils/util'
import logo from 'image/logo_icon.png'
import { ossImg } from 'meinian-package/src/utils/image'
import { PLATFORM_CONFIG_ENUM } from 'meinian-package/src/component/platformConfig'
import ImageDetail from 'view/detail/imageDetail'
import { Layer } from '../image.base'
import { BatchItem } from '../../../batch'
import { StyleStateLabel } from '../styleInfo'
import styles from './index.module.less'

const Image = (props) => {
  const {
    total,
    data = [],
    isBatch,
    onClickCard,
    columnWidth,
    itemData,
    shareUrl,
    action,
    maxHeight = 500,
    viewConfig = {}, // 视图设置
  } = props
  const [visible, setVisible] = useState(false)
  const [lastRouter] = useState(location.pathname + location.search)

  const { collectId, platformId, mainUrl, imageGroupEntityId, inspirationId, loginUserInfo, imageUrlList } = itemData || {}

  const Card = PLATFORM_CONFIG_ENUM.has(platformId) ? Image[PLATFORM_CONFIG_ENUM.get(platformId).component] : null

  const _onChange = (success, newItemData) => {
    if (success) {
      action.onUpdate(newItemData)
      props.onResize?.()
    }
  }

  const auth = loginUserInfo?.inspirationPermissions || []
  return (
    <div
      className={classNames(styles['meinian-waterfall-card-image-wrap'])}
      style={{ width: columnWidth, height: columnWidth, maxHeight }}
    >
      <div
        className="meinian-waterfall-card-image"
        onClick={(e) => {
          if (window.location.pathname.startsWith('/meinian/home/workbench')) {
            util.track('mn-workbench-click', {
              module1: '款式查看',
              module2: props.trackModule2,
              module3: '款式详情',
            })
          }
          history.replaceState(
            {},
            '',
            `/meinian/detail/image?${qs.stringify({
              imageGroupEntityId,
              inspirationId,
              collectId,
              shareUrl,
            })}`
          )
          onClickCard ? onClickCard(itemData, e) : setVisible(true)
        }}
      >
        {!isBatch && columnWidth >= 230 && (
          <Layer
            showMoveImage={props.showMoveImage}
            childrenFlag={props.childrenFlag}
            allStyleFlag={props.allStyleFlag}
            onDeleteItem={() => {
              action.onDelete([itemData.imageGroupEntityId, itemData.inspirationId])
              props.onResize()
            }}
            hiddenMark={viewConfig.markInfo}
            onChange={_onChange}
            itemData={itemData}
          >
            {Card && viewConfig.originalInfo && <Card {...props} />}
          </Layer>
        )}
        {isBatch && (
          <div className="batch-mask">
            <BatchItem keyValue={`${imageGroupEntityId},${inspirationId}`} className="batch-check" info={itemData} />
          </div>
        )}
        <ImageView
          mainUrl={ossImg(mainUrl, 400)}
          style={{ height: columnWidth }}
          secondImgUrl={ossImg(imageUrlList?.[0], 400)}
          firstImgUrl={ossImg(imageUrlList?.[1])}
          lastImgUrl={ossImg(imageUrlList?.[2])}
        />
        <StyleStateLabel auth={auth} itemData={itemData} viewConfig={viewConfig} />
      </div>
      {visible ? (
        <ImageDetail
          list={data}
          maxListLength={total || data.length}
          onChangeIndex={props.onChangeIndex}
          visible={visible}
          onChange={_onChange}
          onVisibleChange={(_visible) => {
            history.replaceState({}, '', lastRouter)
            setVisible(_visible)
          }}
          onDeleteItem={(record) => {
            action.onDelete([record.imageGroupEntityId, record.inspirationId])
            props.onResize()
          }}
          initWaterfall={props.initWaterfall}
          initSubColls={props.initSubColls}
        />
      ) : null}
    </div>
  )
}

export default Image

const ImageView = ({ mainUrl, secondImgUrl, firstImgUrl, lastImgUrl, style }) => {
  return (
    <div className={styles.multiImageView} style={style}>
      <div className={styles.mainImg}>
        <img referrerPolicy="no-referrer" style={{ objectFit: 'cover' }} src={mainUrl || logo} />
      </div>
      <div className={styles.recentUpdateImg}>
        <div className={styles.recentImg1}>
          {firstImgUrl ? (
            <img referrerPolicy="no-referrer" style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={firstImgUrl} />
          ) : (
            <img style={{ width: '34%' }} src={logo} />
          )}
        </div>
        <div className={styles.recentImg2}>
          {secondImgUrl ? (
            <img referrerPolicy="no-referrer" style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={secondImgUrl} />
          ) : (
            <img style={{ width: '34%' }} src={logo} />
          )}
        </div>
        <div className={styles.recentImg3}>
          {lastImgUrl ? (
            <img referrerPolicy="no-referrer" style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={lastImgUrl} />
          ) : (
            <img style={{ width: '34%' }} src={logo} />
          )}
        </div>
      </div>
    </div>
  )
}
